import { api } from '../../api';

const updateTiles = (id, postId, tiles) => {
  return api.patch(`/api/client_admin/campaigns/tiles/${id}`, {
    tile: { post_id: postId, tiles_array: tiles },
  });
};

export const dragEndEffect = (action, listenerApi) => {
  const { tile } = action.payload;
  const postId = tile.status.split('post-')[1] || null;
  const tilesArray = listenerApi.getState().campaignDnd[tile.status];
  const tilePosition = tilesArray.map((tile, index) => ({
    id: tile.id,
    position: index,
  }));

  updateTiles(tile.id, postId, tilePosition);
};
